<template>

        <tr class="permission">
            <td class="name">{{permission.display_name}}</td>
            <td class="description">{{permission.description}}</td>
            <td class="actions">
                <span class="edit" data-toggle="modal" :data-target="'#modal-permission-'+permission.id"><i class="fas fa-edit"></i></span>
                <span class="delete" @click="deletePermission(permission.id)"><i class="far fa-trash-alt"></i></span>
                <div class="modal fade" tabindex="-1"  :id="'modal-permission-'+permission.id" ref="vuemodal">
                    <div class="modal-dialog" role="document">
                        <div class="modal-content">
                            <div class="modal-header bg-primary text-white">
                                <h5 class="modal-title">Atļaujas {{permission.display_name}} labošana</h5>
                                <button type="button" class="close text-white" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div class="modal-body">
                                <div class="row">
                                    <div class="col-12">
                                        <div class="form-group">
                                            <label for="display_name">Nosaukums</label>
                                            <input type="text" v-model="display_name" class="form-control" :class="{'is-invalid':errors && ( 'display_name' in errors)}">
                                            <small class="text-danger" v-if="errors && errors.display_name">{{errors.display_name[0]}}</small>
                                        </div>
                                        <div class="form-group">
                                            <label for="name">Programmatiskais nosaukums</label>
                                            <input type="text" v-model="name" class="form-control" :class="{'is-invalid':errors && ( 'name' in errors)}">
                                            <small class="text-danger" v-if="errors && errors.name">{{errors.name[0]}}</small>
                                        </div>
                                        <div class="form-group">
                                            <label for="description">Apraksts</label>
                                            <input type="text" v-model="description" class="form-control" :class="{'is-invalid':errors && ( 'description' in errors)}">
                                            <small class="text-danger" v-if="errors && errors.description">{{errors.description[0]}}</small>
                                        </div>
                                        <div class="form-group">
                                            <label for="group">Atļaujas grupa</label>
                                            <select v-model="permission_group_id" class="form-control" name="group">
                                                <option v-for="group in groups" :key="group.id" :value="group.id">{{group.name}}</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="modal-footer">
                                <input type="button" class="btn btn-primary" value="Labot" @click="updatePermission()" v-if="loading == false">
                                <button type="button" class="btn btn-primary"  v-if="loading == true"><i class="fas fa-spinner fa-spin"></i></button>
                            </div>
                        </div>
                    </div>
                </div>
            </td>
        </tr>


</template>

<script>
export default {
    props:['permission','groups'],
    mounted()
    {
        this.display_name = this.$props.permission.display_name;
        this.name = this.$props.permission.name;
        this.description = this.$props.permission.description;
        this.permission_group_id = this.$props.permission.permission_group_id;

        $(this.$refs.vuemodal).on("hidden.bs.modal", this.onHide);
    },
    data(){
        return{
            display_name:"",
            name:"",
            description:"",
            permission_group_id:"",
            errors:"",
            loading:false,
            permissionGroups:[],
        }
    },
    methods:
    {
        onHide()
        {
            this.display_name = this.$props.permission.display_name;
            this.name = this.$props.permission.name;
            this.description = this.$props.permission.description;
            this.permission_group_id = this.$props.permission.permission_group_id;
        },

        updatePermission()
        {
            var that = this;
            that.loading = true;
            axios.post('/dashboard/api/permission/'+that.permission.id,{
                name: this.name,
                description:this.description,
                permission_group_id:this.permission_group_id,
                display_name:this.display_name
            }).then(response => {
                if(response.data.status == 'ok')
                {
                     EventBus.$emit('permission_updated');
                    $(that.$refs.vuemodal).modal('hide');
                    that.$toast.open(response.data.message);
                    that.errors = response.data.errors;
                    that.permission = JSON.parse(response.data.permission);
                }
                that.errors = response.data.errors;
                that.loading = false;

            })
        },
        deletePermission(id)
        {
            var that = this;
            this.$swal.fire({
                title: 'Vai tiešām vēlaties dzēst atļauju?',
                text: "Atļauja tiks neatgriezeniski dzēsta!",
                icon: 'question',
                showCancelButton: true,
                confirmButtonText: 'Jā',
                cancelButtonText: 'Atcelt'
            }).then((result) => {
                if(result.value)
                {
                    axios.post('/dashboard/api/permission/'+id+'/delete')
                        .then(response =>{
                             EventBus.$emit('permission_deleted');
                            that.$toast.open({
                                message: response.data.message,
                                type: 'error',
                            });
                        });
                }
            })

        },
    }
}
</script>

<style lang="scss" scoped>
    .permission{
        width:100%;
        .name{
            min-width:200px;
        }
        .description{
            min-width:500px;
        }
        &:hover, &:focus{
            .actions
            {
                span{
                    visibility: visible;

                }
            }
        }
        .actions{
            min-width: 100px;
            span{
                padding:10px;
            }
        }
    }
</style>
